import { Component, OnInit, inject, signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

// PrimeNG 21 Modules
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';

// Services
import { AuthService } from '../services/auth.service';
import { UserSessionService } from '../services/mock-auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ButtonModule, DividerModule],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class LoginComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private mockAuthService = inject(UserSessionService);

  isLoading = signal(false);
  showMockLink = !environment.production && environment.useMockAuth;

  ngOnInit(): void {
    console.log('====== LOGIN COMPONENT INIT ======');
    console.log('🔗 Current URL:', window.location.href);
    console.log('🔗 Query params:', this.route.snapshot.queryParams);
    
    // 🔗 DEEP LINKING: Read returnUrl from query parameters
    const returnUrlParam = this.route.snapshot.queryParams['returnUrl'];
    if (returnUrlParam) {
      console.log('🔗 ReturnUrl from queryParams:', returnUrlParam);
      console.log('🔗 Deep link detected in login page');
      console.log('  - Encoded:', encodeURIComponent(returnUrlParam));
      console.log('  - Decoded:', returnUrlParam);
    } else {
      console.log('🔗 No returnUrl in query params');
    }
    console.log('==================================');
    
    // Check if user is already authenticated
    const isAuthenticated = this.authService.isAuthenticated();
    const mockUser = this.mockAuthService.getCurrentUser();
    
    if (isAuthenticated || mockUser) {
      // User is already logged in
      // 🔗 PRIORITY: If there's a returnUrl, go there instead of default route
      if (returnUrlParam) {
        console.log(`✅ User already authenticated, redirecting to deep link: ${returnUrlParam}`);
        this.router.navigate([returnUrlParam]);
        return;
      }
      
      // No returnUrl - use default route
      const defaultRoute = this.authService.getDefaultRouteForUser();
      console.log(`✅ User already authenticated, redirecting to ${defaultRoute}`);
      this.router.navigate([defaultRoute]);
      return;
    }

    // Auto-redirect to the dev auth-test page in mock mode when not authenticated
    if (environment.useMockAuth) {
      console.log('🔧 Mock auth enabled - redirecting to /auth-test');
      this.router.navigate(['/auth-test']);
    }
  }

  /**
   * Azure AD Login - Redirect to Microsoft login
   * Passes returnUrl to preserve deep link through OAuth flow
   */
  azureLogin(): void {
    this.isLoading.set(true);
    const returnUrlParam = this.route.snapshot.queryParams['returnUrl'];
    
    console.log('====== AZURE AD LOGIN INITIATED ======');
    console.log('🔐 Starting Azure AD login flow');
    if (returnUrlParam) {
      console.log('🔗 Preserving returnUrl for post-login redirect:', returnUrlParam);
      console.log('  - Will be stored in sessionStorage before redirect to Azure AD');
    }
    console.log('======================================');
    
    this.authService.login(returnUrlParam);
  }

  /**
   * Go to the dev auth-test page (development only)
   */
  goToAuthTest(): void {
    this.router.navigate(['/auth-test']);
  }
}
